module.exports = __webpack_public_path__ + "static/img/file_nginx.0344902f.png";